<template>
  <div>
    <form class="form">
      <div class="fieldSet">
        <h3 v-if="bubbleTitle">{{ bubbleTitle }}</h3>
        <div class="field">
          Hola lamentamos mucho que te vayas 🥲, estás a punto de eliminar tu cuenta, esta acción es <strong>Irreversible</strong>.
          <br>
          Al hacerlo perderas acceso a lo siguiente:
          <hr>
          <ol>
            <li>- Tickets para eventos, tanto tickets en curso y utilizados.</li>
            <li>- Comentarios, acciones y registros en nuestra base de datos</li>
            <li>- Historial de compras</li>
            <li>- Cuentas vinculadas</li>
            <li>- Podés volver a crear una cuenta cuando quieras, utilizando el mismo u otro email.</li>
          </ol>
        </div>
        <label>Entiendo y deseo continuar</label>
        <input v-model="accepted" type="checkbox">
        <hr>
        <div class="field">
          <label>{{$t('profile.comments')}}</label>
          <input v-model="reason" type="text" name="" maxlength="200">
        </div>
        <div v-if="accepted">
          <a href="#" class="bt btG" @click.prevent="confirm">{{ $t('profile.removeAccount') }}</a>
        </div>
      </div>
    </form>
    <toast ref="toastMessage">{{ $t('profile.removeAccountConfirmation') }}</toast>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import api from "~/api";

const accepted = ref(false)
const reason = ref('')
const toastMessage = ref(null)
defineProps({
  bubbleTitle: String,
})

onMounted(async () => {})

async function confirm() {
  try {
    await api.User.deleteMyAccount({
      reason: reason.value ?? ''
    })
    toastMessage.value?.activate(3.5)
    reason.value = '';
    accepted.value = false;
  } catch (error: AxiosError) {
    console.log('error');
  }
}
</script>
